


















































































































































import { Component, Prop, Inject, Watch, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import LanguagesButtons from "../../buttons/languages-buttons.vue";
import CloseButton from "@/components/buttons/close-button.vue";
import BSwitch from "../../app/switchs/b-switch.vue";
import UploadImages from "@/components/app/images/upload-images.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import { preferred_language } from "@/config/languags.config.json";
import { pics } from "@/config/host.config";

import { IWikiCategory } from "@/@types/wiki/wiki-object";
import { ILocale } from "@/@types/locale";
import { IWikiType } from "@/@types/wiki/wiki_types";

@Component({
  components: {
    StandartModal,
    submit: SubmitResetButtonGroop,
    UploadImages,
    LanguagesButtons,
    CloseButton,
    BSwitch,
  },
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(25) },
  },
})
export default class WikiCategoryForm extends Vue {
  @Prop({ type: Object, default: null }) category!: IWikiCategory | null;
  @Prop({ type: Array, default: () => [] }) maincats!: Array<IWikiCategory>;
  @Inject({ from: "categoryFolder", default: "" }) readonly iconFolder!: string;

  locale = preferred_language;
  host = pics.upload;
  subtype = IWikiType.sub;
  catIcons: Array<string> = [];

  name = "";
  names: ILocale = {};
  show = true;
  type = this.subtype;
  mainid: Array<string> = [];
  icon = "";

  get cat(): Partial<IWikiCategory> {
    return {
      _id: this.category ? this.category._id : "",
      name: this.names,
      show: this.show,
      type: this.type,
      mainid: this.mainid,
      src: { icon: this.icon },
    };
  }

  mainidChanger(id: string): void {
    const i = this.mainid.findIndex((c) => c == id);
    if (i < 0) this.mainid.push(id);
    else this.mainid.splice(i, 1);
  }

  @Watch("locale")
  changeLocale(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  @Watch("name")
  entryFilmName(): void {
    this.names[this.locale] = this.name;
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");
      this.$v.$touch();
      return;
    }
    this.$emit("updateCat", this.cat);
  }

  onReset(): void {
    this.name = "";
    this.names = {};
    this.show = false;
    this.type = this.subtype;
    this.mainid = [];
    this.icon = "";
  }

  @Watch("category")
  createCategory(): void {
    this.onReset();
    if (!this.category) return;
    this.names = this.category.name;
    this.changeLocale();
    this.show = this.category.show;
    this.type = this.category.type;
    this.mainid = this.category.mainid ? this.category.mainid : [];
    this.icon = this.category.src?.icon ? this.category.src.icon : "";
  }

  async getWikiIcons(): Promise<void> {
    const params = { path: this.iconFolder };
    try {
      const wikiLables = await this.$axios.get(pics.download, { params });
      if (wikiLables.status === 200) {
        this.catIcons =
          wikiLables.data == "Папка не найдена" ||
          wikiLables.data == "Папка пуста"
            ? []
            : wikiLables.data;
      }
    } catch (error) {
      console.error(error);
    }
  }

  mounted(): void {
    this.createCategory();
    this.getWikiIcons();
  }
}
